import { Session } from '@domain/account/models/Session';
import { Token } from '@domain/account/models/Token';
import { User } from '@domain/account/models/User';
import { LastLoginMethod } from '@domain/account/models/LastLoginMethod';
import { SessionDTO, TokenDTO, UserDTO, LastLoginMethodDTO } from '../dto/AuthDTO';

export class AuthMapper {
    static toSessionModel(dto: SessionDTO): Session {
        return {
            id: dto.$id,
            createdAt: new Date(dto.$createdAt),
            userId: dto.userId,
            provider: dto.provider,
            providerUid: dto.providerUid,
            providerAccessToken: dto.providerAccessToken,
            providerAccessTokenExpiry: dto.providerAccessTokenExpiry,
            providerRefreshToken: dto.providerRefreshToken,
            ip: dto.ip,
            osCode: dto.osCode,
            osName: dto.osName,
            osVersion: dto.osVersion,
            clientType: dto.clientType,
            clientCode: dto.clientCode,
            clientName: dto.clientName,
            clientVersion: dto.clientVersion,
            clientEngine: dto.clientEngine,
            clientEngineVersion: dto.clientEngineVersion,
            deviceName: dto.deviceName,
            deviceBrand: dto.deviceBrand,
            deviceModel: dto.deviceModel,
            countryCode: dto.countryCode,
            countryName: dto.countryName,
            current: dto.current,
        };
    }

    static toTokenModel(dto: TokenDTO): Token {
        return {
            id: dto.$id,
            createdAt: new Date(dto.$createdAt),
            userId: dto.userId,
            secret: dto.secret,
            expire: dto.expire,
            phrase: dto.phrase
        };
    }

    static toUserModel(dto: UserDTO): User {
        return {
            id: dto.$id,
            name: dto.name,
            email: dto.email,
            phone: dto.phone,
            impersonator: dto.impersonator === true,
            impersonatorUserId: dto.impersonatorUserId || undefined,
            companies: dto.companies?.map((company) => ({
                id: company.id,
                name: company.name,
                subscriptionStatus: company.subscriptionStatus,
            })),
        };
    }

    static toLastLoginMethodModel(dto: LastLoginMethodDTO): LastLoginMethod {
        switch (dto.lastLoginMethod) {
            case 'email_password':
                return LastLoginMethod.EMAIL_PASSWORD;
            case 'otp':
                return LastLoginMethod.OTP;
        }
    }
}